import cn from 'classnames';
import type { ReactNode } from 'react';
import { Col, Layout, Row } from 'ui';

const { Content, Footer, Header } = Layout;

type P = {
  className?: string;
  contentLeft?: ReactNode;
  contentRight: ReactNode;
  footer: ReactNode;
  header: ReactNode;
  type?: 'public-detail';
};

const LandingLayout = ({ className, contentLeft, contentRight, footer, header, type }: P) => {
  const rightSpan = contentLeft ? 12 : 24;

  return (
    <Layout
      className={cn('landing-layout', className, {
        'landing-layout--public-detail': type === 'public-detail',
      })}
    >
      <Header className="landing-layout__header">{header}</Header>
      <Content className="landing-layout__content">
        <Row className="landing-layout__content__wrapper">
          {contentLeft ? (
            <Col className="landing-layout__content__left" md={{ span: 12 }}>
              {contentLeft}
            </Col>
          ) : null}
          <Col
            className="landing-layout__content__right"
            md={{ offset: 24 - rightSpan, span: rightSpan }}
            xs={{ span: 24 }}
          >
            <div className="landing-layout__content__right-wrapper">{contentRight}</div>
          </Col>
        </Row>
      </Content>
      <Footer className="landing-layout__footer">{footer}</Footer>
    </Layout>
  );
};

export default LandingLayout;
